"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canTakeStick = void 0;
const getNextSpeakerId_1 = require("./getNextSpeakerId");
const hasStickBeenPassed_1 = require("./hasStickBeenPassed");
/**
 * Returns whether or not a participant can take the stick during a discussion.
 */
function canTakeStick(discussion, participantId) {
    return hasStickBeenPassed_1.hasStickBeenPassed(discussion) && getNextSpeakerId_1.getNextSpeakerId(discussion) === participantId;
}
exports.canTakeStick = canTakeStick;
//# sourceMappingURL=canTakeStick.js.map